import { Link } from 'react-router';

// material-ui
import { ButtonBase } from '@mui/material';

// project imports
import Logo from "assets/svg/logo/logo-bcas.png"

// ==============================|| MAIN LOGO ||============================== //

const LogoSection = () => (
    <ButtonBase disableRipple component={Link} to={'/'}>
        <img src={Logo} width={150} alt="" />
    </ButtonBase>
);

export default LogoSection;
